import {
    AlertColor,
    Button,
    Modal,
    TextField,
    Theme,
    Typography,
    useMediaQuery,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { globalTheme } from "../../../common/theme";
import createStyles from "@mui/styles/createStyles";
import axios from "axios";
import React, { useImperativeHandle } from "react";
import { SnackBarMessage, SnackBarMessageProps } from "../../component/SnackBarMessage";
import Title from "../../component/Title";
import { Staff } from "./StaffAccessories";
import { renewToken } from "../../../services/AuthService";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
    })
);

export interface StaffPasswordProps {
    onClose: Function;
}

export interface StaffPasswordHandle {
    Initialise: (staffId: number) => void;
}

export const StaffPassword = React.forwardRef(
    (props: StaffPasswordProps, ref: React.Ref<StaffPasswordHandle>) => {
        const style = { ...useStyles(), ...globalTheme() };

        const tinyScreen = useMediaQuery('(max-width:1366px)');
        const smallScreen = useMediaQuery('(max-width:1920px)');
        const normalScreen = useMediaQuery('(max-width:2560px)');

        const [open, setOpen] = React.useState(false);
        const [hasError, setHasError] = React.useState(false);
        const [staffId, setStaffId] = React.useState<number>();
        const [newPassword, setNewPassword] = React.useState<string>("");
        const [confirmPassword, setConfirmPassword] = React.useState<string>("");

        //Dialogs and snacks
        const [snackSettings, setSnackSettings] =
        React.useState<SnackBarMessageProps>({
            open: false,
            message: "",
            subMessage: "",
            severity: undefined,
            onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
        });

        function showSnackBar(message: string, subMessage: string, colour?: AlertColor) {
            setSnackSettings({
                open: true,
                message: message,
                subMessage: subMessage,
                severity: colour,
                onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
            });
        }

        useImperativeHandle(ref, () => ({
            Initialise(staffId: number) {
                setOpen(true);
                renewToken();

                if (staffId)
                {
                    setStaffId(staffId);
                    setNewPassword("");
                    setConfirmPassword("");
                }
            },
        }));

        function closeModal() {
            setOpen(false);
            props.onClose(true);
        }
          
        function SavePassword() {
            axios.put<boolean>('Api/V1/Staff/UpdatePassword', {}, {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                params: {
                  'staffId': staffId,
                  'newPassword': newPassword
                }
              }).then(
                (result) => {
                    showSnackBar("Password saved successfully.", "", "success");
                    closeModal();
                },
                (error) => {
                    showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
                }
            );
        }

        return (
            <div>
                <Modal open={open} onClose={() => closeModal()}>
                    <div className={style.ModalMainMini}>
                        <div className={style.ModalBody}>
                            <Title pageTitle="Change Password" />

                            <div className={style.ModalHeading}>
                                <Typography variant={ tinyScreen ? "h6" : (smallScreen ? "h5" : "h4") }>Change Password</Typography>
                            </div>

                            <div className={style.ModalContent}>
                                <div className={style.ModalFields}>
                                    <TextField className={style.ModalContentFieldFullWidth}
                                        type="password"
                                        label="New Password"
                                        value = {newPassword ?? ""}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        size="small"
                                    />
                                    <TextField className={style.ModalContentFieldFullWidth}
                                        type="password"
                                        label="Confirm Password"
                                        value = {confirmPassword ?? ""}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        size="small"
                                    />
                                </div>
                            </div>

                            <div className={style.ModalFooter}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    className={style.margin}
                                    onClick={(e) => {
                                            SavePassword();
                                        }}
                                    size="small"
                                    style={{ padding: 1}}
                                >
                                    Save
                                </Button>
                                <div style={{ width: `100%`, minWidth: "10" }}></div>
                                <Button
                                    variant="contained"
                                    className={style.margin}
                                    onClick={(e) => closeModal()}
                                    size="small"
                                    style={{ padding: 1}}
                                >
                                    Close
                                </Button>                                
                            </div>
                        </div>
                    </div>
                </Modal>

                <SnackBarMessage {...snackSettings} />

            </div>
        );


    }

);


